import React, { useEffect } from "react";
import { Select, SelectProps } from "@mantine/core";

const EVENT_EXTERNAL_TYPE_OPTIONS = [
  {
    value: "website",
    label: "Website",
    disabled: false,
  },
  {
    value: "rsvp",
    label: "RSVP",
    disabled: false,
  },
  {
    value: "tickets",
    label: "Tickets",
    disabled: false,
  },
] as const;

export interface EventexternalUrlTypeSelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Current status value (100 for enabled, 0 for disabled) */
  value: string | null | undefined;

  /** Callback when status changes */
  onChange: (value: string | null) => void;
}

export const EventexternalUrlTypeSelector: React.FC<
  EventexternalUrlTypeSelectorProps
> = ({
  value,
  onChange,
  placeholder = "Select external URL type",
  required,
  ...selectProps
}) => {
  // Prepare select data with optional descriptions
  const selectData = EVENT_EXTERNAL_TYPE_OPTIONS.map((option) => {
    let label: string = option.label;

    return {
      value: option.value,
      label,
      disabled: option.disabled,
    };
  });

  // Auto-select first display type if required and no value is set
  useEffect(() => {
    if (required && value == null && onChange) {
      const firstOption = EVENT_EXTERNAL_TYPE_OPTIONS[0];
      if (firstOption && !firstOption.disabled) {
        onChange(firstOption.value);
      }
    }
  }, [required, value, onChange]);

  // Handle change and convert back to number
  const handleChange = (stringValue: string | null) => {
    onChange(stringValue);
  };

  return (
    <Select
      {...selectProps}
      data={selectData}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      clearable={false}
      allowDeselect={false}
      required
      size="md"
    />
  );
};

// Export status options for use in other components
export { EVENT_EXTERNAL_TYPE_OPTIONS };
